import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadAppSettings = createAsyncThunk("appSettings/loadAppSettings", async (_, thunkAPI) => {
  try {
    const response = await API("/app-settings");

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const loadAllFormQuestions = createAsyncThunk("appSettings/getAllQuestionsList", async (_, thunkAPI) => {
  try {
    const response = await API("secure/getAllQuestionsList");

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const loadTestKitPricing = createAsyncThunk("appSettings/getTestKitPricing", async (_, thunkAPI) => {
  try {
    const response = await API("get-kit-pricing");

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const loadSaasPricing = createAsyncThunk("appSettings/getSaasPricing", async (saasId = 0, thunkAPI) => {
  try {
    const response = await API(`get-saas-pricing/${saasId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});
